import script from "./trackedList.vue?vue&type=script&setup=true&lang=ts"
export * from "./trackedList.vue?vue&type=script&setup=true&lang=ts"

import "./trackedList.vue?vue&type=style&index=0&id=7f9b0b2f&lang=scss"

const __exports__ = script;

export default __exports__